import createFavoriteAssetsAtom from './favorite-assets.js'

export const favoriteAssetsAtomDefinition = {
  id: 'favoriteAssetsAtom',
  type: 'atom',
  factory: createFavoriteAssetsAtom,
  dependencies: ['fusion', 'config', 'logger'],
  public: true,
}
